import React from "react";
import { useCheckin } from "../../../../../hooks/useCheckin";
import { MarkdownContent } from "../../../../../../../../../../../shared/MarkdownContent/MarkdownContent";

export function CustomerNotes({ value, setValue }) {
  const { data } = useCheckin();

  return (
    <div className="customer-note">
      <div className="juvly-subtitle m-b-15">
        Select Customer Notes to be sent to provider:
      </div>
      {data.map((obj, i) => (
        <div className="check-note" key={i}>
          <input
            type="checkbox"
            className="note-check"
            name={"notes-" + obj.id}
            checked={value.includes(obj.id) ? "checked" : false}
            onChange={() => {
              if (value.includes(obj.id)) {
                setValue(value.filter((id) => id !== obj.id));
              } else {
                setValue([...value, obj.id]);
              }
            }}
          />
          <div className="check-note-text">
            <b>
              {obj.added_by}, {obj.created}
            </b>
            <MarkdownContent>{obj.notes}</MarkdownContent>
          </div>
        </div>
      ))}
    </div>
  );
}
